export enum ServiceDisplayState {
  Enabled = "enabled",
  Disabled = "disabled",
  Hidden = "hidden",
  Preview = "preview",
}
